import React from 'react';
import { SizeMe } from 'react-sizeme';
import classNames from 'classnames';

import { AppButtons } from '../../screens/HomePage/components/AppButtons';
import { SocialLink } from './components/SocialLink';
import Link from '../Link';

import { isIOS, isAndroidChrome } from '../../../helpers/serverRenderingUtils';
import { clickedFooterLink } from './events';

import LinkStyles from '../PublicWebsiteNav/LinkStyles.sass';
import styles from './styles.sass';

const Footer = () => (
  <SizeMe>
    {({ size: { width } }) => (
      <footer className={styles.footer}>
        <div className={styles.logoAndAppStoreContainer}>
          <Link to="/" onClick={() => clickedFooterLink('Home')}>
            <img
              className={styles.anchorLogo}
              src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4.png"
              srcSet="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4@2x.png 2x"
              alt="Anchor logo"
            />
          </Link>
          <div
            className={classNames(styles.appLinksContainer, {
              [styles.mobileAppButtonContainer]: false || getIsMobile(),
            })}
          >
            <AppButtons
              clickEventLocation="Footer"
              appStoreUrl="https://app.adjust.com/dyvodl2?redirect=https%3A%2F%2Fapps.apple.com%2Fapp%2Fapple-store%2Fid1056182234"
              playStoreUrl="https://app.adjust.com/ju55aik?redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dfm.anchor.android"
              mobileAppStoreUrl="https://app.adjust.com/t1g5iu3?redirect=https%3A%2F%2Fanchor.fm%2Fapp"
              mobilePlayStoreUrl="https://app.adjust.com/qohxi8g?redirect=https%3A%2F%2Fanchor.fm%2Fapp"
            />
          </div>
        </div>
        <hr className={styles.rule} />
        <div className={styles.linksAndSocialContainer}>
          {getFooterContentInOrder(width)}
        </div>
      </footer>
    )}
  </SizeMe>
);

function getIsMobile() {
  return isIOS() || isAndroidChrome();
}

function getFooterContentInOrder(width) {
  if (width <= 600) {
    return (
      <React.Fragment>
        <Links />
        <Rule />
        <SocialLinks />
        <Copyright />
      </React.Fragment>
    );
  }
  if (width <= 1024) {
    return (
      <React.Fragment>
        <Links />
        <div className={styles.tabletWrapper}>
          <Copyright />
          <SocialLinks />
        </div>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <Copyright />
      <Links />
      <SocialLinks />
    </React.Fragment>
  );
}

function Rule() {
  return <hr className={styles.rule} />;
}

function Links() {
  return (
    <div className={styles.linksContainer}>
      <a
        onClick={() => clickedFooterLink('About')}
        className={LinkStyles.link}
        href="/about"
        target="_blank"
        rel="noopener noreferrer"
      >
        ABOUT
      </a>
      <a
        onClick={() => clickedFooterLink('Jobs')}
        className={LinkStyles.link}
        href="/jobs"
        target="_blank"
        rel="noopener noreferrer"
      >
        JOBS
      </a>
      <a
        onClick={() => clickedFooterLink('Legal')}
        className={LinkStyles.link}
        href="/tos"
        target="_blank"
        rel="noopener noreferrer"
      >
        LEGAL
      </a>
      <a
        onClick={() => clickedFooterLink('Help')}
        className={LinkStyles.link}
        href="https://help.anchor.fm"
        target="_blank"
        rel="noopener noreferrer"
      >
        HELP
      </a>
    </div>
  );
}

function SocialLinks() {
  return (
    <div className={styles.socialContainer}>
      <SocialLink platformName="twitter" />
      <SocialLink platformName="instagram" />
      <SocialLink platformName="facebook" />
    </div>
  );
}
function Copyright() {
  return (
    <p className={styles.copyright}>
      2019 &copy; Anchor FM Inc. All rights reserved.
    </p>
  );
}

export { Footer };
